// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".eye-place[data-v-79d0ceab]{position:absolute;right:16px;top:15%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
